var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found__wrap"},[_c('div',{staticClass:"col-md-12 not-found-inner"},[_c('h1',{staticClass:"not-found__title"},[_vm._v(" 404 ")]),_c('p',{staticClass:"not-found__text text-center"},[_vm._v(" "+_vm._s(_vm.$t('notFound.notFoundPage'))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }